/**
 * ProdutoLoteLocalRepository
 *
 * Repositório frontend para lotes de produto no PDV Desktop.
 * Delega ao processo principal via Electron IPC (produtoLotes namespace).
 */
import { getElectronAPI } from "@/plugins/desktop";

const ProdutoLoteLocalRepository = {
  /**
   * Salva (upsert) uma lista de lotes de produto.
   * @param {Array} lotes
   */
  async salvarLotes(lotes) {
    const api = getElectronAPI();
    return api.produtoLotes.salvarLotes(lotes);
  },

  /**
   * Busca todos os lotes de um produto (incluindo sem estoque).
   * @param {number} id_produto
   */
  async buscarLotesPorProduto(id_produto) {
    const api = getElectronAPI();
    return api.produtoLotes.buscarPorProduto(id_produto);
  },

  /**
   * Busca lotes disponíveis (quantidade > 0) de um produto, ordenados por validade.
   * @param {number} id_produto
   */
  async buscarLotesDisponiveisPorProduto(id_produto) {
    const api = getElectronAPI();
    return api.produtoLotes.buscarDisponiveisPorProduto(id_produto);
  },

  /**
   * Reduz a quantidade local de um lote (ao adicionar ao carrinho).
   * @param {number} id_produto_lote
   * @param {number} quantidade
   */
  async baixarQuantidadeLocal(id_produto_lote, quantidade) {
    const api = getElectronAPI();
    return api.produtoLotes.baixarQuantidade(id_produto_lote, quantidade);
  },

  /**
   * Devolve quantidade local de um lote (ao remover do carrinho).
   * @param {number} id_produto_lote
   * @param {number} quantidade
   */
  async devolverQuantidadeLocal(id_produto_lote, quantidade) {
    const api = getElectronAPI();
    return api.produtoLotes.devolverQuantidade(id_produto_lote, quantidade);
  },

  /**
   * Conta o total de lotes cadastrados.
   */
  async contarLotes() {
    const api = getElectronAPI();
    return api.produtoLotes.contar();
  },
};

export default ProdutoLoteLocalRepository;
